module.exports = __webpack_public_path__ + "img/google-logo.e330c30e.svg";